import type { CustomCellRendererProps } from '@mint-lib/ag-grid/react';

import { useTranslation } from '@mint-lib/i18n';
import type { MediaPlan } from '@mint-sdk/api-media-plan';

import { getFormattedValue } from '../../../utils/getFormattedValue.jsx';

const TextRenderer = (params: CustomCellRendererProps<MediaPlan.MediaData>) => {
  const { t } = useTranslation('@myn/planning_v2');

  const formatterFn = () => {
    return params.value;
  };

  const formattedValue = getFormattedValue(params, {
    formatterFn,
    placeholderText: t('Insert'),
  });

  return formattedValue;
};

export default TextRenderer;
